import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { Contact, Entente } from '.';

@Entity('contact_entente')
export default class ContactEntente {
    @PrimaryGeneratedColumn()
    id: number;

    @Column()
    fk_id_entente: number;

    @ManyToOne(() => Entente, (entente) => entente.id)
    @JoinColumn({ name: 'fk_id_entente', referencedColumnName: 'id' })
    entente: Entente;

    @Column()
    fk_id_contact: number;

    @ManyToOne(() => Contact)
    @JoinColumn({ name: 'fk_id_contact', referencedColumnName: 'id' })
    contact: Contact;

    @Column({ nullable: true })
    poste: string;
}
